import React, {useContext, useMemo, useState} from 'react';
import {Button, Select, Space, Typography} from 'antd';
import {GiftOutlined} from '@ant-design/icons';
import {AuthContext} from '../../shared/contexts/authContext';
import {internalApi} from '../../common/axios';
import toast from 'react-hot-toast';
import {useBadgeItemData} from '../probability/useItemData';

const {Text} = Typography;

const PlayerBadgeGrant = ({playerData, setPlayerData}) => {
    const {currentUser} = useContext(AuthContext);
    const {data: badgeRaw} = useBadgeItemData();
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [granting, setGranting] = useState(false);

    const badgeList = useMemo(() => badgeRaw?.[currentUser?.target] || [], [badgeRaw, currentUser]);

    const options = useMemo(() => badgeList.map(b => ({
        value: b.index,
        label: `${b.index} - ${b.name}`,
        name: b.name,
    })), [badgeList]);

    const handleGrant = async () => {
        if (!selectedIndex) {
            toast.error('지급할 뱃지를 선택하세요.');
            return;
        }

        const badge = badgeList.find(b => b.index === selectedIndex);
        if (!badge) {
            toast.error('뱃지 정보를 찾을 수 없습니다.');
            return;
        }

        const badgeContentData = playerData.playerInfo?.badgeContentData || {};
        const nextPlayerInfo = {
            ...playerData.playerInfo,
            badgeContentData: {
                ...badgeContentData,
                BadgeCollections: {
                    ...badgeContentData.BadgeCollections,
                    [selectedIndex]: {
                        badgeIndex: selectedIndex,
                        duplicateCount: 0,
                        badgeGrade: badge.badgeStar,
                    },
                },
                CheckableBadges: [...(badgeContentData.CheckableBadges || []), selectedIndex],
            },
        };

        setGranting(true);
        try {
            await internalApi.post('/player/playInfo', {
                playInfo: nextPlayerInfo,
                userKey: playerData.userKey,
                syncId: playerData.syncId,
            });
            setPlayerData(prev => ({...prev, playerInfo: nextPlayerInfo}));
            toast.success('뱃지가 지급되었습니다.');
            setSelectedIndex(null);
        } catch (e) {
            toast.error(e?.response?.data?.message || '뱃지 지급 실패');
        } finally {
            setGranting(false);
        }
    };

    return (
        <div className="info-section">
            <div className="section-header">
                <GiftOutlined className="section-icon"/>
                <Text strong className="section-title">뱃지 지급</Text>
            </div>
            <Space wrap size="middle" align="center">
                <Select
                    showSearch
                    allowClear
                    value={selectedIndex}
                    onChange={setSelectedIndex}
                    options={options}
                    placeholder="지급할 뱃지 선택 (인덱스 또는 이름 검색)"
                    style={{minWidth: 280}}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                        option?.name?.toLowerCase().includes(input.toLowerCase()) ||
                        String(option?.value).includes(input)
                    }
                    disabled={!playerData.userKey}
                />
                <Button
                    type="primary"
                    icon={<GiftOutlined/>}
                    onClick={handleGrant}
                    loading={granting}
                    disabled={!playerData.userKey || !selectedIndex}
                >
                    지급
                </Button>
            </Space>
        </div>
    );
};

export default PlayerBadgeGrant;
